import { render, staticRenderFns } from "./PlaySolid.vue?vue&type=template&id=5aef989e&"
import script from "./PlaySolid.vue?vue&type=script&lang=ts&"
export * from "./PlaySolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports